const getUpperDocumentTitle = (value: string) => {
  const path = value.match(/(^\/)+([a-z,-]*)/)[2];
  return path.charAt(0).toUpperCase() + path.slice(1);
};

export default getUpperDocumentTitle;
